import { useMemo } from 'react'
import { useGetTags } from '@/api/kubik/infoportal'

export const useJournalTags = (tagId?: number) => {
  const { data, isSuccess, isFetching } = useGetTags(
    {},
    {
      query: {
        staleTime: Infinity,
        select: fetchedData => ({
          data: {
            tags: fetchedData.data?.tags.sort((a, b) => a.priority - b.priority) || [],
            pagination: fetchedData.data?.pagination || { offset: 0, limit: 0, total: 0 },
          },
          meta: fetchedData.meta,
        }),
      },
    },
  )

  const currentTag = useMemo(() => data?.data?.tags.find(tag => tag.id === tagId), [data, tagId])

  return { currentTag, tags: data?.data?.tags, isTagsLoaded: isSuccess, isTagsLoading: isFetching }
}
